import { atom } from "jotai";
import { ChatResponse, ThinkingStep } from "../models";
import { WebSocketHook } from "react-use-websocket/dist/lib/types";
import { WebSocketChatResponse } from "../../../contexts/useDeepchat";
import { SIDEBAR_STATE, SidebarPanel } from "../../../constants/sidebarEnums";

export const QuestionTextAtom = atom<string>("");

export const QuestionIsLoadingAtom = atom<boolean>(false);

export const QuestionTargetSalesData = atom<boolean>(false);

// This is to prevent user feedback from being submitted before the server has saved a session, which would result in an error
export const QuestionCanAcceptFeedback = atom<boolean>(false);

export const SessionThreadAtom = atom<ChatResponse[]>([]);

export const ThinkingStepsAtom = atom<ThinkingStep[]>([]); //Holds thinking steps for the current question, will reset on new question submission

export const ThinkingStepsCollapsedAtom = atom<boolean>(true); //Set to false to expand dropdown on thinking steps render

export const FocusedThreadQuestion = atom<ChatResponse | undefined>(undefined);

/** Which panel is currently expanded in the ChatSidebar icon rail */
export const SidebarActivePanelAtom = atom<SidebarPanel>(SIDEBAR_STATE.CLOSED);

/** Whether the sidebar drawer is expanded (showing labels) or collapsed (icon rail only) */
export const SidebarDrawerExpandedAtom = atom<boolean>(false);

export const DeepchatSocketAtom = atom<
  WebSocketHook<WebSocketChatResponse<unknown>, MessageEvent<unknown> | null> | undefined
>(undefined);
